import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { makeUserParticipant } from "api/services/user-service";

export const useMakeUserParticipant = () => {
    const { callAPI, loading } = useWorkspaceApiCall(makeUserParticipant, '', 'makeUserParticipant.error');

    const makeUserParticipantCall = useCallback(async (userId: string) => {
        return await callAPI({ userId });
    }, [callAPI]);

    return { makeUserParticipant: makeUserParticipantCall, makingUserParticipant: loading };
}